<template>
  <div>
    <v-layout align-center justify-space-between>
      <span class="headline"> Subcontractors </span>
      <v-btn color="green darken-2" class="ma-0" @click="dialog = true">
        New subcontractor
      </v-btn>
    </v-layout>

    <v-container>
      <template v-if="loading">
        <v-layout class="mt-5" justify-center>
          <v-progress-circular size="50" indeterminate />
        </v-layout>
      </template>

      <template v-else-if="subcontractors.length === 0">
        <v-layout class="mt-5" justify-center>
          <span class="title">No subcontractors.</span>
        </v-layout>
      </template>

      <template v-else>
        <v-data-table :headers="headers" :items="subcontractors" hide-actions>
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                {{ props.item.name }}
              </td>
              <td>
                <router-link
                  :to="{ name: 'subcontractor', params: { id: props.item.id } }"
                  class="clickable"
                >
                  {{
                    props.item.id | formatSId(props.item.region)
                  }}</router-link
                >
              </td>
              <td>
                {{ props.item.states | nameList }}
              </td>
              <td class="text-xs-center">
                {{ props.item.franchisesCount }}
              </td>
              <td class="text-xs-center">
                {{ props.item.rating | displayRating }}
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <v-container>
              <v-layout>
                <v-flex> Please add a subcontractor </v-flex>
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </template>
    </v-container>

    <v-dialog v-model="dialog" persistent max-width="50rem">
      <v-card>
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex>
                <v-form v-model="valid">
                  <v-text-field
                    v-model="newSubcontractor.name"
                    :rules="[(v) => !!v || 'Name is required']"
                    label="Name"
                  />
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="posting" flat @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn :disabled="posting || !valid" flat @click="save">
            <v-progress-circular v-if="posting" />
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  filters: {
    displayRating(rating) {
      return rating ? parseFloat(rating).toFixed(1) : "";
    },
    nameList(states) {
      let names = states.map((s) => s.name);
      return names.join(", ");
    },
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "Name",
          value: "name",
          width: "20%",
        },
        {
          text: "ID",
          value: "id",
          width: "10%",
        },
        {
          text: "States",
          value: "states",
        },
        {
          text: "Number of franchises",
          value: "franchisesCount",
          align: "center",
          width: "15%",
        },
        {
          text: "Rating",
          value: "rating",
          align: "center",
          width: "10%",
        },
      ],
      loading: false,
      newSubcontractor: { name: "" },
      posting: false,
      subcontractors: [],
      valid: false,
    };
  },
  created() {
    this.loading = true;
    this.$http
      .get("/api/subcontractors")
      .then((r) => (this.subcontractors = Array.from(r.data)))
      .finally(() => (this.loading = false));
  },
  methods: {
    save() {
      this.posting = true;
      this.$http
        .post("/api/subcontractors", { name: this.newSubcontractor.name })
        .then((r) => {
          this.$http.get("/api/subcontractors");
          this.$router.push({
            name: "subcontractor",
            params: { id: r.data.id },
          });
        })
        .finally(() => (this.posting = false));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Subcontractors.vue